import { hasPermission } from "@/router/protected-routes"
import type { RouteRecordRaw } from "vue-router"

const operationsRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "operationList",
    component: () => import("@/templates/operations/OperationList.vue")
  },
  {
    path: "view/:operationId(\\d+)",
    name: "operationView",
    component: () => import("@/templates/operations/OperationView.vue"),
    meta: { breadcrumb: "general.view" }
  },
  {
    path: "create",
    name: "operationCreateAndReview",
    component: () => import("@/views/OperationCreateView.vue"),
    meta: { breadcrumb: "operations.create" },
    children: [
      {
        path: "",
        name: "operationCreate",
        component: () => import("@/templates/operations/OperationCreate.vue")
      },
      {
        path: "review",
        name: "operationReview",
        component: () => import("@/templates/operations/OperationReview.vue"),
        meta: { breadcrumb: "operations.reviewPage.title" }
      }
    ],
    beforeEnter: () => {
      return hasPermission("/api/v1/operation", "post")
    }
  }
]

export default operationsRoutes
